// INTEGRACIONES AVISOS
export const GET_SUB_COMPANIES = 'integraciones/avisos/GET_SUB_COMPANIES';
export const LIST_INTEGRATORS = 'integraciones/avisos/LIST_INTEGRATORS';
export const UPSERT_INTEGRATION = 'integraciones/avisos/UPSERT_INTEGRATION';
export const REMOVE_XML_INTEGRATION = 'integraciones/avisos/REMOVE_XML_INTEGRATION';
export const GET_CURRENT_INTEGRATION = 'integraciones/avisos/GET_CURRENT_INTEGRATION';
export const CLEAR_CURRENT_INTEGRATION = 'integraciones/avisos/CLEAR_CURRENT_INTEGRATION';
export const CLEAR_UPSERT_INTEGRATION = 'integraciones/avisos/CLEAR_UPSERT_INTEGRATION';

// INTEGRACIONES LEADS
export const LIST_LEADS_INTEGRATORS = 'integraciones/leads/LIST_LEADS_INTEGRATORS';
export const GET_LEADS_COMPANY_BRANCHES = 'integraciones/leads/GET_LEADS_COMPANY_BRANCHES';
export const GET_CURRENT_LEADS_INTEGRATIONS = 'integraciones/leads/GET_CURRENT_LEADS_INTEGRATIONS';
export const ADD_LEADS_INTEGRATION = 'integraciones/leads/ADD_LEADS_INTEGRATION';
export const REMOVE_LEADS_INTEGRATION = 'integraciones/leads/REMOVE_LEADS_INTEGRATION';
export const CLEAR_REMOVED_LEADS_INTEGRATION = 'integraciones/leads/CLEAR_REMOVED_LEADS_INTEGRATION';
export const CLEAR_CURRENT_LEADS_INTEGRATIONS = 'integraciones/leads/CLEAR_CURRENT_LEADS_INTEGRATIONS';
export const CLEAR_ADDED_LEADS_INTEGRATION = 'integraciones/leads/CLEAR_ADDED_LEADS_INTEGRATION';
